import type { HTMLAttributes } from 'react';
import cn from 'classnames';
import { useCommentsContext } from './comments-context.tsx';

/** Width of the comments gutter column in the split views. */
export const SPLIT_GUTTER_WIDTH = 220;

/**
 * Virtuoso row wrapper for the split views (#2244). The comments gutter
 * is absolutely positioned over the pane's right edge, so rows keep that
 * strip clear whenever there is a card or a draft to show. Without it
 * the cards cover the translated text. The padding is the gutter width
 * plus an 8px gap; Tailwind needs the literal class.
 */
export function SplitGutterItem({
  children,
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) {
  const ctx = useCommentsContext();
  const hasGutter = !!ctx && (ctx.allComments.length > 0 || ctx.draft != null);
  return (
    <div {...props} className={cn(className, hasGutter && 'lg:pr-[228px]')}>
      {children}
    </div>
  );
}
